import React, { useContext } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const calculateTotal = () => {
    let total = 0;
    cartItems.forEach((item) => {
      const product = getProductById(item.id);
      if (product) {
        const price = parseFloat(product.price.replace(/,/g, ""));
        total += price * item.quantity;
      }
    });
    return total;
  };

  const subtotal = calculateTotal();

  const handleUpdateQuantity = (id, size, color, newQuantity) => {
    if (newQuantity > 0) {
      updateQuantity(id, size, color, newQuantity);
    }
  };

  const handleCheckout = () => {
    if (cartItems.length > 0) {
      navigate("/checkout");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      alert("Your cart is empty");
    }
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-page">
        <div className="cart-empty">
          <h1>Your cart is empty</h1>
          <Link to="/shop" onClick={toTop} className="continue-shopping-btn">
            Continue shopping
          </Link>
        </div>
      </div>
    );
  }

  const recommendedProducts = productData.slice(0, 4);

  return (
    <div className="cart-page">
      <div className="cart-container">
        <div className="cart-main">
          <h1 className="cart-title">Cart</h1>
          
          <div className="cart-items">
            {cartItems.map((item) => {
              const product = getProductById(item.id);
              if (!product) return null;
              
              return (
                <div key={`${item.id}-${item.size}-${item.color}`} className="cart-item">
                  <div className="cart-item-image">
                    <Link to={`/shopDetails/${product.id}`} onClick={toTop}>
                      <img src={product.image} alt={product.name} />
                    </Link>
                    <button 
                      className="remove-btn"
                      onClick={() => removeFromCart(item.id, item.size, item.color)}
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                      </svg>
                    </button>
                  </div>
                  
                  <div className="cart-item-details">
                    <div className="cart-item-info">
                      <Link to={`/shopDetails/${product.id}`} onClick={toTop} className="cart-item-name">
                        {product.name}
                      </Link>
                      
                      <div className="quantity-controls">
                        <button 
                          className="quantity-btn"
                          onClick={() => handleUpdateQuantity(item.id, item.size, item.color, item.quantity - 1)}
                        >
                          −
                        </button>
                        <span className="quantity-value">{item.quantity}</span>
                        <button 
                          className="quantity-btn"
                          onClick={() => handleUpdateQuantity(item.id, item.size, item.color, item.quantity + 1)}
                        >
                          +
                        </button>
                      </div>
                    </div>
                    
                    <div className="cart-item-price">
                      €{(parseFloat(product.price) * item.quantity).toFixed(2)}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="remove-link">
            <button 
              onClick={() => {
                cartItems.forEach(item => removeFromCart(item.id, item.size, item.color));
              }}
              className="remove-all-btn"
            >
              Remove
            </button>
          </div>

          <div className="recommended-section">
            <h3 className="recommended-title">Goes great with</h3>
            <div className="recommended-grid">
              {recommendedProducts.map((product) => (
                <Link 
                  key={product.id}
                  to={`/shopDetails/${product.id}`} 
                  onClick={toTop}
                  className="recommended-item"
                >
                  <div className="recommended-image">
                    <img src={product.image} alt={product.name} />
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>

        <div className="cart-sidebar">
          

          <div className="cart-summary">
            <div className="summary-row">
              <span>Subtotal</span>
              <span>€{subtotal.toFixed(2)}</span>
            </div>

            

            <button className="checkout-btn" onClick={handleCheckout}>
              Check out
            </button>

            <Link to="/shop" onClick={toTop} className="continue-shopping-link">
              Continue shopping
            </Link>

            <div className="tax-info">
              <p>Taxes included. Shipping and discount codes calculated at checkout.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartPage;
